import styled from "styled-components/macro";
const defaultLanguage = window.localStorage.getItem("rcml-lang") || "en";

export const FooterBox = styled.div`
    color: #fff;
    height: auto;
    width: 100%;
    overflow: scroll;
    overflow-x: hidden;
    overflow-y: hidden;
    /* background-color: #FBFCFC;   */
    /* background-color: yellow;   */
    display: flex;
    justify-content: center;
    position: relative;
    margin-top: 10rem;
    @media(max-width: 497px){
        margin-top: 3rem;;
    /* background-color: aqua; */
    }
    @media(max-width: 497px){
        margin-top: 3rem;;
    /* background-color: aqua; */
    }
`
export const FooterContainer = styled.div`
    height: auto;
    width: 1200px;
    display: flex;
    flex-direction: column;
    /* background-color: #FBFCFC; */
    color: #000000;

    @media(max-width: 1351px){
        width: 100%;
        padding: 0 1rem;
        /* background-color: aqua; */
    }
`
export const FotBoxRowOne = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding: 2rem 0;
    border-bottom: 0.5px solid lightgray;
    direction: ${defaultLanguage === "ar" ? "rtl" : "ltr"};
    @media(max-width: 768px){
        flex-direction: column;
        justify-content: center;
        align-items: center;
    }
`
export const FotBoxOne = styled.div`
    height: auto;
    width: auto;
    display: flex;
    flex-direction: column;
    @media (max-width: 527px) {
        margin-bottom: 0.8rem;
    }
`
export const FotBoxFirst = styled.div`
    height: auto;
    width: 100%;
    padding: 0.8rem 0;
    text-align: ${defaultLanguage === "ar" ? "right" : "left"};
    font-size: 1.3rem;
    font-weight: 500;
    font-family: "Montserrat";
    letter-spacing: 0px;
    color: #000000;
    margin-bottom: 0.7rem;
    opacity: 1;
    @media(max-width: 1175px){
        font-size: 1.1rem;
    }
    @media(max-width: 862px){
        font-size: 1rem;
    }
    @media(max-width: 527px){
        margin-bottom: 0;
        padding: 0.5rem 0;
    }
    `
export const FotBoxSecond = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: left;
    align-items: ${defaultLanguage === "ar" ? "start" : "unset"};
`
export const FotBoxCon = styled.a`
    height: auto;
    width: auto;
    text-align: left;
    font-weight: 400;
    font-size: 1rem;
    letter-spacing: 0px;
    color: #000000;
    opacity: 1;
    cursor: pointer;
    margin-bottom: 1.2rem;
    @media(max-width: 1175px){
        font-size: 0.9rem;
        margin-bottom: 0.8rem;
    }
    @media(max-width: 862px){
        font-size: 0.8rem;
    }


    &:last-child {
    margin-bottom: 0;
  }
`
export const FotBoxTwo = styled.div`
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-around;
`
export const FooterContext = styled.div`
height: auto;
width: auto;
text-align: left;
font: 500 14px/20px Montserrat;
letter-spacing: 0px;
color: black;
opacity: 0.4;
`


export const FooterLogo = styled.img`
 width: 30%;
 @media(max-width: 768px){
        width: 18%;
}
 @media(max-width: 561px){
        width: 19%;
}
 @media(max-width: 466px){
        width: 30%;
}
 @media(max-width: 321px){
        width: 35%;
}
`

export const FoLogoBox = styled.div`
    height: auto;
    width: 100%;
    padding: 0.8rem 0;
    text-align: ${defaultLanguage === "ar" ? "right" : "left"};
    /* @media(max-width: 768px){
        text-align: left;
    } */
`


export const AppIconBox = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-top: 1.5rem;

    img {
        max-width: 100%;
        max-height: 32px;
    }
`


export const AppStoreIcon = styled.img`
//  width: 30%;
//  @media (max-width: 769px) {
//     width: 17%;
//  }
//  @media (max-width: 561px) {
//     width: 21%;
//  }
//  @media (max-width: 466px) {
//     width: 25%;
//  }
//  @media (max-width: 321px) {
//     width: 33%;
//  }
`

export const GoogleStoreIcon = styled.img`
 margin-left: ${defaultLanguage === "ar" ? "0" : "1rem"};
 margin-right: ${defaultLanguage === "ar" ? "1rem" : "0"};
//  width: 33%;
//  @media (max-width: 769px) {
//     width: 18%;
//  }
//  @media (max-width: 561px) {
//     width: 21%;
//  }
//  @media (max-width: 466px) {
//     width: 28%;
//  }
//  @media(max-width: 321px){
//         width: 37%;
// }
`

export const FooterDescText = styled.div`
    font-family: "Montserrat";
    opacity: 1;
    color: #000000;
    font-size: 0.9rem;
    line-height: 1.6rem;
    font-weight: 400;
`


export const FotBoxSocial = styled.div`
display: flex;
justify-content: start;
align-items: center;
margin-top: 1.4rem;

&:first-child {
    margin-top: 0;
  }
`

export const SocialIconBox = styled.div`
    background: #15396D 0% 0% no-repeat padding-box;;
    border-radius: 4px;
    opacity: 1;
    padding: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: ${defaultLanguage === "ar" ? "0" : "1rem"};
    margin-left: ${defaultLanguage === "ar" ? "1rem" : "0"};
    @media (max-width: 862px) {
        padding: 0.3rem;
        margin-right: 0.7rem;
    }
`


export const PropertyLocation = styled.img`
 width: 30%
`
export const SocialText = styled.div`
  @media (max-width: 1175px) {
    font-size: 0.9rem;
  }
  @media (max-width: 861px) {
    font-size: 0.8rem;
  }
`
export const InnerBoxOne = styled.div`
  width: 32%;
  /* background-color: brown; */
  @media (max-width: 769px) {
    width: 100%;
  }
`
export const InnerBoxTwo = styled.div`
  width: 66%;
  /* background-color: lightgray; */
  display: flex;
  justify-content: space-between;
  align-items: ${defaultLanguage === "ar" ? "start" : "unset"};
  @media (max-width: 769px) {
    width: 100%;
    margin-top: 1rem;
  }
  @media (max-width: 527px) {
    flex-direction: column;
  }
`
